///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Params } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuditEvent, PagedModel } from '../../../generated/spring-types.model';
import { ITEMS_PER_PAGE } from '../../../shared/constants/pagination.constants';

const AUDITS_API_URL = 'management/audits';
const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSZZZZZ";

@Injectable()
export class AuditsService {
    constructor(
        private readonly http: HttpClient,
        private readonly datePipe: DatePipe
    ) {}

    query(queryParams: Params): Observable<PagedModel<AuditEvent>> {
        return this.http.get<PagedModel<AuditEvent>>(AUDITS_API_URL, {
            params: this.preparePaginationParams(queryParams, new HttpParams())
        });
    }

    public preparePaginationParams(queryParams: Params, params: HttpParams): HttpParams {
        const { from, to, page } = queryParams;
        if (from) {
            params = params.append('fromDate', encodeURIComponent(this.datePipe.transform(new Date(from), DATE_FORMAT)));
        }
        if (to) {
            params = params.append('toDate', encodeURIComponent(this.datePipe.transform(new Date(to), DATE_FORMAT)));
        }
        params = params.append('page', page - 1);
        params = params.append('size', ITEMS_PER_PAGE);
        return params;
    }
}
